import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { themeSpace, themeMediaQuery } from '@utils/styledTheme.util';
import { Text } from '@components/typography';
import { TextPairing } from '@components/TextPairing';
import { Columns } from '@components/Columns';
import { CTALink } from '@components/CTALink';

export const StyledDesktopLoader = styled.div`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledMobileLoader = styled.div`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
  }
`;

export const StyledRegistryCross = styled(Box)`
  position: relative;
  background-color: #ffffff;
`;

export const StyledCenterBody = styled(Box)`
  width: 100%;
`;

export const FeatureImage = styled(Flex)`
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(117, 156, 255, 0.1);
  border-radius: 50%;
  > img {
    max-width: 100%;
  }
`;

export const ButtonsContainer = styled(Flex)`
  max-width: 620px;
  justify-content: center;
  align-items: center;
  > a {
    background: none;
  }
  > *:not(:first-child) {
    margin-left: ${themeSpace(10)};
  }
  ${themeMediaQuery('below_sm')} {
    flex-direction: column;
    > *:not(:first-child) {
      margin-left: ${themeSpace(0)};
      margin-top: ${themeSpace(8)};
    }
  }
`;

export const StyledAppCTALink = styled(CTALink)`
  margin-top: 62px;
  margin-left: 64px;
  ${themeMediaQuery('below_sm')} {
    margin-left: 34px;
    /* margin-left: 0px;
    display: flex;
    align-items: center;
    justify-content: center; */
  }
`;

export const FeatureText = styled(Text)`
  margin-top: ${themeSpace(4)};
  max-width: 190px;
  ${themeMediaQuery('below_sm')} {
    margin-bottom: ${themeSpace(8)};
  }
`;

export const CrossTextPairing = styled(TextPairing)`
  .text-pairing-body {
    max-width: 500px;
  }
  .text-pairing-title {
    max-width: 500px;
    font-size: 56px;
    line-height: 68px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      max-width: 500px;
      font-size: 40px;
      line-height: 46.88px;
    }
    .text-pairing-body {
      max-width: 100%;
    }
  }
  ${themeMediaQuery('md')} {
    .text-pairing-title {
      max-width: 500px;
    }
    .text-pairing-body {
      max-width: 510px;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-body {
      max-width: 500px;
    }
    .text-pairing-title {
      max-width: 576px;
    }
  }
`;

export const StyledTextColumn = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

export const JoyOverviewColumns = styled(Columns)`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
    padding-left: 0;
    padding-right: 0;
  }
`;

export const JoyOverviewColumnsMobile = styled(Columns)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
    padding-left: 0;
    padding-right: 0;
  }
`;

export const JoyOverviewColumn = styled(Columns.Column)`
  ${themeMediaQuery('below_sm')} {
    padding-left: 0;
    padding-right: 0;
  }
`;
